import Vuelidate from "vuelidate";

import { ModalPlugin } from "./modal";
import { PermissoesPlugin } from "./permissoes";
import { FormPlugin } from "./form";
import { Plugin } from 'vue-fragment'


import { BootstrapVue } from "bootstrap-vue";


export * from "./utility";
export * from "./containers";
export * from "./form";
export * from "./permissoes";
export * from "./tabela";
export * from "./modal";
export * from "./telas";
export * from "./misc";
export * from "./mixin";

export const HcBoot = {
  install
};

function install(Vue, customOptions) {
  Object.assign(options, customOptions);

  Vue.use(Plugin)

  //Vue.use(BootstrapVue);

  Vue.use(ModalPlugin);
  // vuelidate
  Vue.use(Vuelidate);

  Vue.use(PermissoesPlugin, []);

  Vue.use(FormPlugin);
}


export const options =  {

}
